module.exports = __webpack_public_path__ + "static/img/f_first_04.b0375a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_04.png
// module id = j+J2
// module chunks = 9